import { ConfigProvider, GlobalToken, theme } from "antd";
import { AliasToken } from "antd/es/theme/internal";
import { PropsWithChildren, ReactElement, useMemo } from "react";
import StyledThemeProvider from "./theme/StyledThemeProvider.tsx";

export type TokenOverrideFactory = (token: GlobalToken) => Partial<AliasToken>;

export interface ThemeOverrideProviderProps {
  overrideTokens: Partial<AliasToken> | ((token: GlobalToken) => Partial<AliasToken>);
}

/**
 * Provides the option to locally override the Ant Design theme tokens.
 */
export default function ThemeOverrideProvider({ children, overrideTokens }: PropsWithChildren<ThemeOverrideProviderProps>): ReactElement {
  const { token } = theme.useToken();

  const overriddenTokens = useMemo(
    () => typeof overrideTokens === "function"
      ? overrideTokens(token)
      : overrideTokens,
    [overrideTokens, token],
  );

  return (
    <ConfigProvider theme={{ token: overriddenTokens }}>
      <StyledThemeProvider>
        {children}
      </StyledThemeProvider>
    </ConfigProvider>
  );
}
